import {
  DashboardOutlined as DashboardOutlinedIcon,
  ExitToAppRounded as ExitToAppRoundedIcon,
  ExpandLess,
  ExpandMore,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  PlaylistAddCheck as PlaylistAddCheckIcon,
  PostAddRounded as PostAddRoundedIcon
} from '@material-ui/icons';

import clsx from 'clsx';
import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
//import useModulePermissions from '../../../../../../hooks/useModulePermissions';
// ajuste a constante abaixo conforme o código real do módulo Partner
import { AMODULO_PARTNER } from 'consts';

const MODULO_PARTNER = AMODULO_PARTNER;

const useStyles = makeStyles((theme) => ({
  menu: { paddingLeft: theme.spacing(1) },
  submenu: { paddingLeft: theme.spacing(1) },
  subSubmenu: { paddingLeft: theme.spacing(1) },

  icon: {
    minWidth: 32,
    color: '#546e7a'
  },

  subtleTitle: {
    fontWeight: 500,
    color: '#3c4345'
  },

  submenuFade: {
    animation: `$fadeInSlide 600ms ease-out`,
    position: 'relative',
    zIndex: 5,
    backgroundColor: '#fff',
    borderRadius: 6,
    boxShadow: '0 0 0 rgba(0, 0, 0, 0)',
    padding: '4px 0',
    animationFillMode: 'forwards',
    transition: 'box-shadow 600ms ease, background-color 600ms ease'
  },

  '@keyframes fadeInSlide': {
    from: {
      opacity: 0,
      transform: 'translateY(-8px)',
      boxShadow: '0 0 0 rgba(0, 0, 0, 0)',
      backgroundColor: 'transparent'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
      backgroundColor: '#fff'
    }
  },

  faded: {
    opacity: 0.3,
    transition: 'opacity 600ms ease'
  },

  disabledItem: {
    opacity: 0.45,
    cursor: 'not-allowed'
  },

  emptyMessage: {
    paddingLeft: theme.spacing(4),
    opacity: 0.6,
    fontStyle: 'italic'
  }
}));

/*
  Estrutura:
  - pais/intermediários normalmente sem permCode
  - folhas (último nível) com permCode
  - troque os permCode abaixo pelos códigos reais do módulo Partner
*/
const menuConfig = [
  {
    key: 'agenda-escalas',
    label: 'Agenda Escalas',
    to: '/partner/agendaescalafornecedor',
    icon: PlaylistAddCheckIcon,
    //permCode: 0 // ajuste para o código real ** por hora sempre logou tem acesso ao menu - sempre habilitado
  },
  {
    key: 'logout',
    label: 'Sair',
    to: '/logout',
    icon: ExitToAppRoundedIcon,
    //permCode: 0
  }
];

/*
  Comportamento estilo Delphi:
  - pai sempre aparece
  - folha sem permissão aparece desabilitada
  - folha com permissão aparece habilitada
*/
function buildMenuDelphiStyle(items, hasPerm) {
  return (items || []).map((item) => {
    const hasChildren = !!(item.children && item.children.length > 0);
    const isLeaf = !hasChildren;

    if (isLeaf) {
      const allowed = !item.permCode || hasPerm(item.permCode);

      return {
        ...item,
        visible: true,
        disabled: !allowed,
        children: []
      };
    }

    const children = buildMenuDelphiStyle(item.children || [], hasPerm);

    const hasAnyEnabledChild = children.some((child) => !child.disabled);

    return {
      ...item,
      visible: true,
      disabled: false,
      hasAnyEnabledChild,
      children
    };
  });
}

const Sidebar = () => {
  const classes = useStyles();

  //const { hasPerm, loading } = useModulePermissions(MODULO_PARTNER);
  const hasPerm = true;
  const loading = false; 

  const [openMap, setOpenMap] = useState({});

  const setOpen = (key, value) =>
    setOpenMap((prev) => ({ ...prev, [key]: value }));

  const isOpen = (key) => !!openMap[key];

  const isPartnerFixedMenu = true;

  const finalMenu = useMemo(() => {
    if (isPartnerFixedMenu) {
      return buildMenuDelphiStyle(menuConfig, () => true);
    }
    return buildMenuDelphiStyle(menuConfig, hasPerm);
  }, [hasPerm]);

  const topOpenKeys = finalMenu
    .filter((i) => i.children && i.children.length > 0)
    .map((i) => i.key);

  const anyTopOpen = topOpenKeys.some((k) => isOpen(k));

  const renderItems = (items, level = 0, parentItem = null) => {
    return items.map((item) => {
      if (!item.visible) return null;

      const Icon = item.icon;
      const hasChildren = item.children && item.children.length > 0;

      const levelClass =
        level === 0
          ? classes.menu
          : level === 1
            ? classes.submenu
            : classes.subSubmenu;

      const siblings = parentItem ? parentItem.children || [] : finalMenu;
      const siblingKeys = siblings
        .filter((s) => s.children && s.children.length > 0)
        .map((s) => s.key);

      const anySiblingOpen = siblingKeys.some((k) => isOpen(k));

      const faded =
        level === 0 ? anyTopOpen && !isOpen(item.key) && hasChildren : false;

      if (!hasChildren) {
        const commonProps = {
          key: item.key,
          className: clsx(levelClass, item.disabled && classes.disabledItem)
        };

        if (item.disabled) {
          return (
            <ListItem
              {...commonProps}
              button={false}
            >
              <ListItemIcon className={classes.icon}>
                {Icon ? <Icon /> : null}
              </ListItemIcon>

              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ className: classes.subtleTitle }}
              />
            </ListItem>
          );
        }

        return (
          <ListItem
            {...commonProps}
            button
            component={Link}
            to={item.to}
          >
            <ListItemIcon className={classes.icon}>
              {Icon ? <Icon /> : null}
            </ListItemIcon>

            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ className: classes.subtleTitle }}
            />
          </ListItem>
        );
      }

      return (
        <div
          key={item.key}
          onMouseEnter={() => setOpen(item.key, true)}
          onMouseLeave={() => setOpen(item.key, false)}
        >
          <ListItem
            button
            className={clsx(
              levelClass,
              anySiblingOpen && !isOpen(item.key) && parentItem && classes.faded,
              faded && classes.faded
            )}
          >
            <ListItemIcon className={classes.icon}>
              {Icon ? <Icon /> : null}
            </ListItemIcon>

            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ className: classes.subtleTitle }}
            />

            {isOpen(item.key) ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={isOpen(item.key)} timeout={600} unmountOnExit>
            <List
              component="div"
              disablePadding
              className={classes.submenuFade}
            >
              {item.children && item.children.length > 0 ? (
                renderItems(item.children, level + 1, item)
              ) : (
                <ListItem className={levelClass}>
                  <ListItemText
                    primary="Nenhuma opção disponível"
                    primaryTypographyProps={{ className: classes.emptyMessage }}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </div>
      );
    });
  };

  return (
    <List>
      {isPartnerFixedMenu ? renderItems(finalMenu) : (
        loading ? (
          <ListItem>
            <ListItemText primary="Carregando permissões..." />
          </ListItem>
        ) : (
          renderItems(finalMenu)
        )
      )}
    </List>
  );
};

export default Sidebar;